import { render, staticRenderFns } from "./RestrictedInfo.vue?vue&type=template&id=2d16f6b0&"
import script from "./RestrictedInfo.vue?vue&type=script&lang=js&"
export * from "./RestrictedInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports